import { Component, Input } from '@angular/core';
import { CustomerFacade } from '../../../+store/customer/customer.facade';
import { NzFormModule } from 'ng-zorro-antd/form';
import { FormsModule } from '@angular/forms';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzInputNumberModule } from 'ng-zorro-antd/input-number';
import { CommonModule } from '@angular/common';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { ACTIVITY_TYPES, CreateActivityDTO } from '@care-portals/api-interfaces';
import { NzDrawerRef } from 'ng-zorro-antd/drawer';
@Component({
  selector: 'portals-emr-create-activity',
  templateUrl: './create-activity.component.html',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    NzFormModule,
    NzInputModule,
    NzInputNumberModule,
    NzSelectModule,
    NzButtonModule
  ]
})
export class CreateActivityComponent {
  @Input() resourceId: string;
  @Input() resourceType: string;
  @Input() customerId: string;
  @Input() type: ACTIVITY_TYPES;
  ACTIVITY_TYPES = ACTIVITY_TYPES;

  form:any = {
    callDuration: 0
  };
  note: string ='';

  constructor(
    private readonly customerFacade: CustomerFacade,
    private readonly nzDrawerRef: NzDrawerRef
  ) {}

  closeDrawer() {
    this.nzDrawerRef.close();
  }

  async submit(event: Event) {
    event.preventDefault();
    const data: CreateActivityDTO = {
      type: this.type as ACTIVITY_TYPES,
      note: this.note,
      customer: this.customerId,
      meta: {
        resourceId: this.resourceId,
        resourceType: this.resourceType,
        ...this.form
      }
    };
    await this.customerFacade.createActivity(data).then(() => {
      this.closeDrawer();
    });
  }
}
